<script>
    export default {
        name: "Authenticitysection"
    }
</script>

<template>
  <div class="row authenticity">
    <div class="container">
      <section class="section">
        <div class="text-authenticity">
          <h2>
            <span class="title-authenticity"> Autenticidade Garantida das transações!</span>
          </h2>
          <p>Todas as transações realizadas são registradas em uma rede pública de blockchain, garantindo sua autenticidade. Essas operações poderão ser verificadas de qualquer lugar e momento no futuro, para comprovar a lisura do processo de captação de recursos.</p>
          <p>
            Veja todas as doações realizadas na interface do Voto Legal.
          </p>
          <p>
            <a
              class="call-to-action-button"
              href="https://blockchain2020.votolegal.com.br"
            >
              Explore
            </a>
          </p>
        </div>

        <img
          class="img-authenticity"
          src="../../img/authenticity/img-blockchain.png"
          srcset="../../img/authenticity/img-blockchain.png 1x, ../../img/authenticity/img-blockchain@2x.png 2x, ../../img/authenticity/img-blockchain@3x.png 3x"
          alt="O Voto Legal e Decred"
        >
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .call-to-action-button {
      display: inline-block;

      padding: 0.6rem 2rem;
      margin-top: 1rem;

      font-weight: 600;
      font-size: 1em;
      line-height: 1.5;

      text-align: center;
      text-transform: uppercase;

      color: #ffffff;

      background-color: transparent;

      border: 2px solid #ffffff;
      border-radius: 8px;
    }


      p {
        margin-bottom: 1.5em;
      }

      .authenticity {
          background-color: #2e656f;
      }
      .section {
          overflow: hidden;
      }

      @media screen and (min-width: 768px) {
          .text-authenticity {
              float: right;

              width: 50%;
          }
      }

      .title-authenticity {
          color: #ffffff;
      }

      .text-authenticity p {
          font-size: 18px;
          line-height: 2;

  		color: #ffffff;

  		@media (max-width: 913px) {
  			margin-bottom: 2em;
  		}
      }

      .img-authenticity {
  		display: block;

          margin-right: auto;
          margin-left: auto;

          ---position: relative;

      }

</style>



// WEBPACK FOOTER //
// _source/javascript/components/authenticitysection.vue